import { reducer as form } from 'redux-form';
import { routerReducer as routing } from 'react-router-redux';

import auth from './auth';
import customers from './customers';
import decisions from './decisions';
import payment from './payment';
import liability from './liability';
import translations from './translations';
import ui from './ui';
import error from './error';
import questions from './questions';
import wordpress from './wordpress';
import notifications from './notifications';
import headers from './headers';
import profile from './profile';
import fileUpload from './file-upload';
import sap from './sap';
import zipCode from './zipCode';

import snackbar from './snackbar';

export default {
  form,
  auth,
  zipCode,
  customers,
  decisions,
  payment,
  liability,
  translations,
  ui,
  error,
  questions,
  wordpress,
  notifications,
  headers,
  profile,
  fileUpload,
  sap,
  routing,
  snackbar
};
